import { LocaleEnum } from '@systemeio/ui'

export const getSuccessfullyContactImportLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/4456-linee-guida-generali-e-best-practice-per-la-deliverability-delle-email-nei-primi-giorni'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/4288-orientacoes-gerais-e-praticas-recomendadas-para-a-entregabilidade-de-emails-durante-os-primeiros-dias'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/4495-allgemeine-richtlinien-und-bewahrte-vorgehensweisen-fur-die-e-mail-zustellbarkeit-in-den-ersten-tagen'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/4402-directrices-generales-y-buenas-practicas-para-la-entregabilidad-del-correo-durante-los-primeros-dias'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/9946-general-guidelines-and-best-practices-for-email-deliverability-during-the-first-few-days'
    }
    case LocaleEnum.CHINESE: {
      return 'https://help-zh.systeme.io/article/4312-general-guidelines-and-best-practices-for-email-deliverability-during-the-first-few-days'
    }
    case LocaleEnum.HINDI: {
      return 'https://help-hi.systeme.io/article/4396-general-guidelines-and-best-practices-for-email-deliverability-during-the-first-few-days'
    }
    default: {
      return 'https://help.systeme.io/article/4247-general-guidelines-and-best-practices-for-email-deliverability-during-the-first-few-days'
    }
  }
}
